/* LA Pool & Spas homepage: live "open now" badge, today's hours highlight,
   weekday-only promos and upcoming holiday closures. Store time = America/Edmonton.
   Data comes from snippets/lps-store-data.liquid (Theme settings → Store hours & location). */
(function () {
  if (window.lpsStore) return;
  var TZ = 'America/Edmonton';
  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function readData() {
    var el = document.querySelector('[data-lps-store-data]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function parseRange(str) {
    var m = String(str || '').trim().match(/^(\d{1,2})(?::(\d{2}))?\s*-\s*(\d{1,2})(?::(\d{2}))?$/);
    if (!m) return null;
    var open = (+m[1]) * 60 + (+(m[2] || 0));
    var close = (+m[3]) * 60 + (+(m[4] || 0));
    return close > open ? { open: open, close: close } : null;
  }

  function parseClosed(text) {
    var out = {};
    String(text || '').split(/[\r\n,]+/).forEach(function (line) {
      var m = line.trim().match(/^(\d{4}-\d{2}-\d{2})\s*(.*)$/);
      if (m) out[m[1]] = m[2].trim();
    });
    return out;
  }

  function storeNow() {
    var parts = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23', weekday: 'short'
    }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    var dow = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }[parts.weekday];
    return {
      y: +parts.year, mo: +parts.month, d: +parts.day, dow: dow,
      min: (+parts.hour % 24) * 60 + (+parts.minute)
    };
  }

  function dayInfo(now, offset) {
    var dt = new Date(Date.UTC(now.y, now.mo - 1, now.d + offset));
    var iso = dt.toISOString().slice(0, 10);
    return { iso: iso, dow: (now.dow + offset) % 7, month: dt.getUTCMonth(), date: dt.getUTCDate() };
  }

  function fmt(min) {
    var h = Math.floor(min / 60), m = min % 60, suf = h >= 12 ? 'PM' : 'AM';
    var h12 = h % 12 || 12;
    return h12 + (m ? ':' + (m < 10 ? '0' : '') + m : '') + ' ' + suf;
  }

  function compute(data) {
    var now = storeNow();
    var closed = parseClosed(data.closed);
    var today = dayInfo(now, 0);
    var todayRange = closed[today.iso] !== undefined ? null : parseRange(data.hours[now.dow]);
    var res = { now: now, today: today, closed: closed, state: 'closed', text: '' };

    if (todayRange && now.min < todayRange.close) {
      if (now.min >= todayRange.open) {
        var left = todayRange.close - now.min;
        res.state = left <= 30 ? 'closing' : 'open';
        res.text = (left <= 30 ? 'Closing soon' : 'Open now') + ' · until ' + fmt(todayRange.close);
      } else {
        res.state = 'later';
        res.text = 'Opens today at ' + fmt(todayRange.open);
      }
      return res;
    }

    var prefix = closed[today.iso] !== undefined
      ? 'Closed today' + (closed[today.iso] ? ' for ' + closed[today.iso] : '')
      : 'Closed now';
    for (var i = 1; i <= 14; i++) {
      var d = dayInfo(now, i);
      if (closed[d.iso] !== undefined) continue;
      var r = parseRange(data.hours[d.dow]);
      if (!r) continue;
      var when = i === 1 ? 'tomorrow' : DAY_NAMES[d.dow];
      res.text = prefix + ' · opens ' + when + ' at ' + fmt(r.open);
      return res;
    }
    res.text = prefix;
    return res;
  }

  function update() {
    var data = readData();
    if (!data || !window.Intl) return;
    var res;
    try { res = compute(data); } catch (e) { return; }

    document.querySelectorAll('[data-lps-status]').forEach(function (el) {
      var t = el.querySelector('[data-lps-status-text]');
      if (t) t.textContent = res.text;
      el.setAttribute('data-state', res.state);
      el.hidden = false;
    });

    document.querySelectorAll('[data-lps-dows]').forEach(function (el) {
      var list = el.getAttribute('data-lps-dows').split(',');
      el.classList.toggle('is-today', list.indexOf(String(res.now.dow)) !== -1);
    });

    // Weekday-only content, e.g. the Tuesday deal. Hidden on holiday closures.
    var openToday = res.state !== 'closed';
    document.querySelectorAll('[data-lps-day]').forEach(function (el) {
      var match = el.getAttribute('data-lps-day') === String(res.now.dow) && openToday;
      if (el.hasAttribute('data-lps-day-badge')) {
        el.classList.toggle('is-active-day', match);
      } else {
        el.hidden = !match;
      }
    });

    // Next holiday closure within 21 days.
    var notice = '';
    for (var i = 0; i <= 21; i++) {
      var d = dayInfo(res.now, i);
      if (res.closed[d.iso] !== undefined) {
        var name = res.closed[d.iso];
        var when = i === 0 ? 'today' : i === 1 ? 'tomorrow' : DAY_NAMES[d.dow] + ', ' + MONTHS[d.month] + ' ' + d.date;
        notice = 'Closed ' + when + (name ? ' for ' + name : '') + '.';
        break;
      }
    }
    document.querySelectorAll('[data-lps-closure]').forEach(function (el) {
      el.textContent = notice;
      el.hidden = !notice;
    });
  }

  window.lpsStore = { update: update };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
  else update();
  setInterval(update, 60000);
  document.addEventListener('shopify:section:load', update);
})();
